export default [{
	titulo: 'Voltagem',
	icone: 'menu-icon fa fa-caret-right',
	url: '/admin/voltagem',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]